import React from "react";
import ResortingAndPackagingInfo from "../../../components/FactoryModule/ResortingAndPackaging/ResortingAndPackaging.component";

export default class ResortingAndPackagingScreen extends React.Component {
  render() {
    return <ResortingAndPackagingInfo />;
  }
}
